import { render, staticRenderFns } from "./ScormPayloadInfoIcon.vue?vue&type=template&id=f39ca4de"
import script from "./ScormPayloadInfoIcon.vue?vue&type=script&lang=js"
export * from "./ScormPayloadInfoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports